import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[megaStoreAdminTextOnly]'
})
export class TextOnlyDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const regex = /^[a-zA-Z\s]*$/;
    if (!regex.test(input.value)) {
      event.preventDefault();
      input.value = input.value.replace(/[^a-zA-Z\s]/g, '');
    }
  }
}
